import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router';
import { Button } from '../ui/index.js';
import styles from './Shell.module.css';

/**
 * The route error boundary. A screen that fails to load, most often a chunk from a build that
 * a later deploy replaced, lands here instead of on the router's default page. A reload picks
 * up the current build.
 */
export function AppError() {
  const error = useRouteError();
  const navigate = useNavigate();
  const notFound = isRouteErrorResponse(error) && error.status === 404;
  const detail = isRouteErrorResponse(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : '';
  return (
    <div className={styles.blockedWrap}>
      <div className={styles.blocked}>
        <h1 className={styles.blockedTitle}>{notFound ? 'There is nothing at this address' : 'Titan could not load this screen'}</h1>
        <p className={styles.blockedBody}>
          {notFound
            ? 'The link may be old or mistyped. The home screen lists everything your account can open.'
            : 'Reloading usually fixes it: the console may have been updated while this page was open. If it keeps happening, tell your DinoCloud team and mention the time.'}
        </p>
        {detail && <p className={styles.blockedDetail}>{detail}</p>}
        <div className={styles.blockedActions}>
          {!notFound && <Button onClick={() => window.location.reload()}>Reload</Button>}
          <Button variant="secondary" onClick={() => navigate('/')}>
            Back to home
          </Button>
        </div>
      </div>
    </div>
  );
}
